export const cardText = [
    {
        htmlEl: "h2",
        varName: "name",
    }
]